/**
 * @generated SignedSource<<3737b16511fe1807cc15c5e2a86dee2f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RoutineEditMainDuplicateMutation$variables = {
  id: string;
};
export type RoutineEditMainDuplicateMutation$data = {
  readonly routine: {
    readonly duplicate: {
      readonly id: string;
    } | null;
  } | null;
};
export type RoutineEditMainDuplicateMutation = {
  response: RoutineEditMainDuplicateMutation$data;
  variables: RoutineEditMainDuplicateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "RoutineMutation",
    "kind": "LinkedField",
    "name": "routine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "duplicate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RoutineEditMainDuplicateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RoutineEditMainDuplicateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bdd8ac5de928824b53e3ea88488b246b",
    "id": null,
    "metadata": {},
    "name": "RoutineEditMainDuplicateMutation",
    "operationKind": "mutation",
    "text": "mutation RoutineEditMainDuplicateMutation(\n  $id: ID!\n) {\n  routine(id: $id) {\n    duplicate {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7813446e040b71bce6d662dc1d155a16";

export default node;
